import React from "react";

import ManageMerchantUsers from "./manage/ManageMerchantUsers";

class ManageUserModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const { id, merchant, retrieveMerchants } = this.props;
		return (
			<div id={id} className="uk-modal-container">
				<div className="uk-modal-dialog uk-modal-body">
					<h2 className="uk-modal-title">Manage Users</h2>
					{merchant && (
						<ManageMerchantUsers
							merchant={merchant}
							readOnly={merchant.isArchive}
							retrieveMerchants={retrieveMerchants}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default ManageUserModal;
